/**
 * Shopify TypeScript Theme Toolkit
 * Main entry point - exports all features and utilities
 */

// Core types
export * from './types/shopify';
export * from './types/events';
export * from './types/settings';

// Utilities
export * from './utils/shopify-api';
export * from './utils/storage';
export * from './utils/dom';

// Features
export { VariantSelector } from './features/variant-selector';
export { CartDrawer } from './features/cart-drawer';
export { ProductRecommendations } from './features/recommendations';

// Rules
export * from './features/cart-drawer/rules';

// Recommendation sources
export * from './features/recommendations/sources';

// Version
export const VERSION = '1.0.0';

// Global initialization
console.log(`Shopify Toolkit v${VERSION} initialized`);
